import { Label } from './label.js';
import { cn } from '../../lib/utils.js';

const FALLBACK = '#6C5CE7';

// Swatch + hex input in one control. The native picker drives the
// swatch; the text field accepts a typed hex so a brand colour can be
// pasted straight in.
export function ColorField({
  id,
  label,
  value,
  onChange,
  className,
  labelClassName = 'eyebrow',
}: {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  className?: string;
  labelClassName?: string;
}) {
  // The native input rejects anything that isn't a full hex, so fall back
  // rather than let it silently reset while the user is mid-type.
  const isHex = /^#[0-9a-fA-F]{6}$/.test(value);
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={id} className={labelClassName}>
        {label}
      </Label>
      <div className="flex h-11 items-center gap-2 rounded-md border border-border bg-card px-2 transition-colors focus-within:border-transparent focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-1 focus-within:ring-offset-background dark:border-white/10 dark:bg-card-raised">
        <input
          type="color"
          value={isHex ? value : FALLBACK}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          aria-label={`Pick ${label.toLowerCase()}`}
          className="h-7 w-9 cursor-pointer rounded border border-border bg-transparent p-0"
        />
        <input
          id={id}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={FALLBACK}
          className="h-full flex-1 bg-transparent font-mono text-[12px] uppercase tracking-[0.04em] outline-none placeholder:text-muted-foreground/70"
        />
      </div>
    </div>
  );
}
